import axios from '@/axios.js'

let entityURL = 'platforms'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = {'Authorization': `bearer ${token}`}

const state = {
    platforms: [],
    selectedPlatform: null,
    platformConnectionFields: [],
}

const getters = {
    // Local State Data
    getAvailablePlatforms: (state) => (state.platforms),
    getSelectedPlatform: (state) => (state.selectedPlatform),
    getPlatformConnectionFields: (state) => (state.platformConnectionFields),

}

const actions = {
    async fetchAvailablePlatforms({commit}) {
        const response = await axios(`${entityURL}/all`)
        commit('SET_PLATFORMS', response.data.object)
    },
    async fetchPlatformConnectionFields({commit}, payload) {
        const response = await axios(`${entityURL}/fields/${payload}`)
        commit('SET_PLATFORM_CONNECTION_FIELDS', response.data.object)
    },
    async updatePlatformConnectionFields({commit}, payload) {
        const response = await axios.post(`${entityURL}/fields/save`, payload)
        commit('SET_PLATFORM_CONNECTION_FIELDS', payload)
        return response
    },
    async updateSelectedPlatform({commit}, payload) {
        const response = await axios(`${entityURL}/set/${payload.id}`)
        // commit('SET_SELECTED_PLATFORM', payload)
    },
    async setSelectedPlatform({commit}, payload) {
        commit('SET_SELECTED_PLATFORM', payload)
    },
    async platformProductsImport({commit}) {
        const response = await axios(`${entityURL}/import-products`)
        return response
    },
    async platformProductsUpdate({commit}) {
        const response = await axios(`${entityURL}/update-products`)
        return response
    },

}

const mutations = {
    SET_PLATFORMS: (state, data) => (state.platforms = data),
    SET_PLATFORM_CONNECTION_FIELDS: (state, data) => (state.platformConnectionFields = data),
    SET_SELECTED_PLATFORM: (state, data) => (state.selectedPlatform = data),
}

export default {state, getters, actions, mutations}
